import { render, staticRenderFns } from "./t-app-header-search-button.vue?vue&type=template&id=b95fd78a&scoped=true&"
import script from "./t-app-header-search-button.vue?vue&type=script&lang=js&"
export * from "./t-app-header-search-button.vue?vue&type=script&lang=js&"
import style0 from "./t-app-header-search-button.vue?vue&type=style&index=0&id=b95fd78a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95fd78a",
  null
  
)

export default component.exports